/* eslint-disable no-unused-vars */
import React, { useContext } from "react";
import ConfigurationContext from "../../src/context/Configuration";

const GOOGLE_MAPS_LIBRARIES = [
  "places",
  "drawing",
  "geometry",
  "visualization",
];

/**
 * Central configuration for all external services and API keys
 * @returns {Object} Configuration object with all service endpoints and keys
 */
const ConfigurableValues = () => {
  const configuration = useContext(ConfigurationContext);
  // Backend GraphQL API endpoints
  const SERVER_URL = "https://borku.up.railway.app/";
  const WS_SERVER_URL = "wss://borku.up.railway.app/";

  // const SERVER_URL = 'https://5k2n1mch-8001.inc1.devtunnels.ms/'
  // const WS_SERVER_URL = 'wss://5k2n1mch-8001.inc1.devtunnels.ms/'

  // const SERVER_URL = 'https://borku1.up.railway.app/'
  // const WS_SERVER_URL = 'wss://borku1.up.railway.app/'
  // Google OAuth client ID for authentication
  const GOOGLE_CLIENT_ID = '459224613075-481r74uoao2efg2qpa6it3vetcnpt90j.apps.googleusercontent.com';
  // const GOOGLE_CLIENT_ID = configuration.webClientID;
  // Payment gateway keys
  const STRIPE_PUBLIC_KEY = configuration.publishableKey;
  const PAYPAL_KEY = configuration.clientId;
  // Google Maps API key for location services
  // const GOOGLE_MAPS_KEY = configuration.googleApiKey;
  const GOOGLE_MAPS_KEY = "AIzaSyB68jtBQprbPfyopTR5GVQ5-6uqdPX1xdk"
  // Analytics tracking key
  const AMPLITUDE_API_KEY = configuration.webAmplitudeApiKey;
  // Google Maps libraries required for the application.
  // Kept as a module-level constant so the array identity is stable — passing a
  // fresh array to useJsApiLoader makes it tear down and re-load the Maps script
  // on every render. "localContext" is deliberately absent: Google turned that
  // library down, and asking for it makes the whole Maps bootstrap fail with
  // "The library localContext is unknown", so no map on the site ever loads.
  const LIBRARIES = GOOGLE_MAPS_LIBRARIES;
  // UI theme colors
  const COLORS = {
    GOOGLE: configuration.googleColor,
  };
  // Error tracking and monitoring
  const SENTRY_DSN = configuration.webSentryUrl;
  // Feature flags for verification processes
  const SKIP_EMAIL_VERIFICATION = configuration.skipEmailVerification;
  const SKIP_MOBILE_VERIFICATION = configuration.skipMobileVerification;
  // Cloudinary uploads
  const CLOUDINARY_UPLOAD_URL = configuration.cloudinaryUploadUrl;
  const CLOUDINARY_FOOD = configuration.cloudinaryApiKey;

  console.log(CLOUDINARY_UPLOAD_URL)
  console.log(CLOUDINARY_FOOD)


  return {
    SERVER_URL,
    WS_SERVER_URL,
    GOOGLE_CLIENT_ID,
    COLORS,
    PAYPAL_KEY,
    STRIPE_PUBLIC_KEY,
    GOOGLE_MAPS_KEY,
    AMPLITUDE_API_KEY,
    LIBRARIES,
    SENTRY_DSN,
    SKIP_EMAIL_VERIFICATION,
    SKIP_MOBILE_VERIFICATION,
    CLOUDINARY_UPLOAD_URL,
    CLOUDINARY_FOOD,
  };
};

export default ConfigurableValues;
